import { useHistory } from "react-router";
import { useNavigate, useNavigation } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
  margin: calc(2 * var(--u)) 0;
  width: 100%;
  height: calc(14 * var(--u));
  max-height: calc(14 * var(--u));
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1000;
`;

const Back = styled.button`
  position: absolute;
  width: calc(6 * var(--u));
  height: calc(6 * var(--u));
  aspect-ratio: 134 / 121;
  top: calc(4 * var(--u));
  left: calc(4 * var(--u));
  z-index: 100;
  background: url("/assets/ui/Nav-Retour.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
`;

export function Subheader({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  return (
    <Container>
      <Back onClick={() => navigate(-1)} />
      {children}
    </Container>
  );
}
